import {v4 as uuidv4} from "uuid";
import messageIdMapping from "../IdMappings/MessageIdMapping.ts";
import {updateMessageImportanceState, updateMessagesSequenceState} from "../db/chatHistory/chatMetadataUtils.ts";
import {MessageNode} from "./MessageNode.ts";

export const setupUserMessage = (content: any) => {
    let promptPostFix = "";

    return {
        content: content,
        promptPrefix: "",
        truncatedPromptPrefix: null,
        promptPostfix: promptPostFix,
        truncatedPromptPostfix: null,
        role: 'user'
    };
}

export const addChild = (message: any, currentMessageRef: any, messagesSequenceRef: any, messageId: string | null = null) => {
    try {
        const lastChildIndex = currentMessageRef.current.children.length;

        const metadata: any = {timestamp: Date.now()};

        const uuid = messageId ?? uuidv4();
        const node = new MessageNode(uuid, lastChildIndex, message, [], currentMessageRef.current.id, metadata);
        currentMessageRef.current.children.push(uuid);

        currentMessageRef.current = node;
        if (messagesSequenceRef) messagesSequenceRef.current.push(lastChildIndex);
    } catch (error) {
        console.log(error);
    }
}

export const addAdjacentMessage = (editedContent: any[], index: number, messagesRef: any, currentMessageRef: any, messagesSequenceRef: any, llmRequestRefs: any) => {
    currentMessageRef.current = messagesRef.current;
    for (let i = 0; i < index; i++) {
        currentMessageRef.current = messageIdMapping[currentMessageRef.current.children[messagesSequenceRef.current[i]]];
    }
    const lastChildIndex = currentMessageRef.current.children.length;

    const newContent = editedContent.filter(
        (item: any) => item.type !== "text" || (item.type === "text" && item.text.trim() !== "")
    );

    // Create new message by spreading the existing message and updating content
    const userMessage = setupUserMessage(newContent);
    const metadata: any = {timestamp: Date.now()};

    const uuid = uuidv4();
    const node = new MessageNode(uuid, lastChildIndex, userMessage, [], currentMessageRef.current.id, metadata);
    currentMessageRef.current.children.push(uuid);

    messagesSequenceRef.current[index] = lastChildIndex;
    messagesSequenceRef.current = messagesSequenceRef.current.slice(0, index + 1);
    currentMessageRef.current = node;

    llmRequestRefs.current.parentMessage = messageIdMapping[node.parent!];
    llmRequestRefs.current.messagesToWrite.push(currentMessageRef.current);
}

export const handleChangeStateIndex = (user: any, isIncognito: boolean, conversationId: string, index: number, forward: boolean, messagesSequenceRef: any, currentMessageRef: any, setMessages: any, messagesRef: any) => {
    if (forward) messagesSequenceRef.current[index] += 1;
    else messagesSequenceRef.current[index] -= 1;
    messagesSequenceRef.current = messagesSequenceRef.current.slice(0, index + 1);

    currentMessageRef.current = messagesRef.current;

    let i = 0;
    while (currentMessageRef.current.children.length !== 0) {
        let childIndex = 0;
        if (messagesSequenceRef.current.length > i) {
            childIndex = messagesSequenceRef.current[i];
        } else {
            messagesSequenceRef.current.push(0);
        }
        currentMessageRef.current = messageIdMapping[currentMessageRef.current.children[childIndex]];
        i++;
    }

    setMessages(messagesRef.current.deepCopy());
    if (conversationId) updateMessagesSequenceState(user, isIncognito, conversationId, messagesSequenceRef.current);
}

export const clearMessages = (messagesRef: any, currentMessageRef: any, messagesSequenceRef: any) => {
    messagesRef.current = null;
    currentMessageRef.current = null;
    messagesSequenceRef.current = [];

    Object.keys(messageIdMapping).forEach(key => delete messageIdMapping[key]);
}

export const toggleMessageImportance = async (user: any, isIncognito: boolean, conversationId: string, messageId: string, markAsImportant: boolean, updateImportantMessageIds: any, setMessages: any) => {
    if (markAsImportant) updateImportantMessageIds(messageId, "add");
    else updateImportantMessageIds(messageId, "delete");

    setMessages((prev: any) => prev.deepCopy());

    await updateMessageImportanceState(user, isIncognito, conversationId, messageId, markAsImportant);
}
